import CommonLandingContainer from '../../../../landingComponents/containers/common';
import styles from './advice.module.scss';
import {
  Heading1,
  Heading2,
  Title,
  SubTitle,
  Body,
  SmallText,
  SecondaryText,
  Info,
  Button,
  Heading3,
} from '../../../../landingComponents/typography';
import InfoPanel from '../../../../landingComponents/containers/infoPanel';
import AnimatedBox from 'src/components/landingComponents/containers/animatedScroll';
import { getClassName } from 'src/Core/utility/jsx';
import LandingButton from '../../../../landingComponents/button';
import TextField from '@mui/material/TextField';
import { useState } from 'react';
import useApi from 'src/Api/useApi';

const Advice = () => {
  return (
    <CommonLandingContainer className={styles.container}>
      <AdviceBlock />
      <DevelopmentBlock />
    </CommonLandingContainer>
  );
};

export default Advice;

const AdviceBlock = () => {
  return (
    <AnimatedBox className={getClassName([styles.adviceBlock])}>
      <InfoPanel
        Header={() => (
          <Heading3 className={styles.title} accent>
            Дайте нам совет
          </Heading3>
        )}
      >
        <SecondaryText>
          Мы будем рады любой обратной связи от наших пользователей
        </SecondaryText>
      </InfoPanel>
      {/* <Heading3 className={styles.title} accent>Дайте нам совет</Heading3> */}
      <Form />
    </AnimatedBox>
  );
};

const Form = () => {
  const [name, setName] = useState('');
  const [buttonName, setButtonName] = useState('Отправить');
  const [mail, setMail] = useState('');
  const [advice, setAdvice] = useState('');
  const [error, setError] = useState(null);
  const { api, inProgress } = useApi();

  const onSubmit = async () => {
    if (advice?.length < 10) {
      setError("Заполните это поле");
      return
    }

    await api('landing/submitAdvice', {
      mail,
      name,
      advice,
    });

    setButtonName('Спасибо!')
  };

  const font = {
    '& .MuiInputBase-input': {
      fontFamily: 'Mulish, sans-serif',
      color: '#6d7578',
    },
    '& .MuiInputLabel-root': {
      fontFamily: 'Mulish, sans-serif',
      color: '#6d7578',
    },
    '& .MuiInputBase-root': {
      fontFamily: 'Mulish, sans-serif',
      color: '#6d7578',
    },
    '& .MuiInput-input::placeholder': {
      opacity: 1,
    },
  };

  return (
    <div className={styles.form}>
      <TextField
        id="name"
        label="Ваше имя"
        variant="standard"
        value={name}
        onChange={(event) => {
          setName(event.target.value);
        }}
        sx={{ ...font }}
        disabled={inProgress}
      />
      <TextField
        id="mail"
        label="Ваша почта"
        variant="standard"
        value={mail}
        onChange={(event) => {
          setMail(event.target.value);
        }}
        sx={{ ...font }}
        disabled={inProgress}
      />
      <TextField
        error={!!error}
        id="advice"
        placeholder="Введите текст"
        multiline
        minRows={2}
        maxRows={4}
        variant="standard"
        value={advice}
        onChange={(event) => {
          error && setError(null);
          setAdvice(event.target.value);
        }}
        sx={{ ...font }}
        helperText={error}
        disabled={inProgress}
      />
      <LandingButton
        variant="contained"
        onClick={onSubmit}
        disabled={inProgress || buttonName != 'Отправить'}
      >
        <Button>{buttonName}</Button>
      </LandingButton>
    </div>
  );
};

const DevelopmentBlock = () => {
  return (
    <AnimatedBox className={getClassName([styles.development])}>
      <InfoPanel
        className={styles.infoBlock}
        Header={() => (
          <Title accent>Наша система находится на этапе развития</Title>
        )}
      >
        <div className={styles.infoTexts}>
          <SecondaryText>
            Мы постоянно дополняем её новыми алгоритмами, поэтому на данный
            момент какие-то специфические маркеры и алгоритмы не будут
            представлены в системе, однако могут появиться в ближайшее время.
          </SecondaryText>
          <SecondaryText>
            Также система не будет распознавать те маркеры, которые не
            упоминаются в клинических рекомендациях, либо являются слишком
            специфическими (например маркеры генетических дефектов ферментных
            систем).
          </SecondaryText>
        </div>
      </InfoPanel>
    </AnimatedBox>
  );
};
